import { useContext } from 'react';
import { type Ancestor } from '#enums/ancestors.ts';
import { Context } from './Context.ts';

export const useAncestors = () => useContext(Context);

export const useIsAncestor = (name: Ancestor) => {
  const ancestors = useAncestors();
  return ancestors.includes(name);
};
